import React, { useState } from "react";
import Leftbar from "../../components/Leftsidebar";
import Topbar from "../../components/Topbar";
import { Link } from "react-router-dom";



const ViewUser = () => {

  const [showSidebar, setShowSidebar] = useState(false);


  const handleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const handleSidebarClose = () => {
    setShowSidebar(false);
  };


  return (
    <>
      <div class="g-sidenav-show  bg-gray-100">
        <div id="wrapper">
          <Leftbar showSidebar={showSidebar}
            handleSidebarClose={handleSidebarClose} />
          <main className="main-content border-radius-lg">
            <Topbar handleSidebar={handleSidebar} />

            <div className="header header-bg pb-6">
              <div className="container-fluid">
                <div className="header-body">
                  <div className="row align-items-center py-4">
                    <div className="col-lg-6 col-7">
                      <nav
                        aria-label="breadcrumb"
                        className="d-none d-md-inline-block ml-md-4"
                      >
                        <ol className="breadcrumb breadcrumb-links breadcrumb-dark" style={{ background: "transparent" }}>
                          <li className="breadcrumb-item">
                            <Link to="/dashboard">
                              <i className="fas fa-home" />
                            </Link>
                          </li>
                          <li className="breadcrumb-item mt-1">
                            <a className="" href="/view-user/101" style={{ fontSize:"15px" }}>View User</a>
                          </li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="container-fluid mt--6">
              <div className="row">
                <div className="col">
                  <div className="card">
                    <div className="card-body">

                      <div className="col-md-12">
                        <div
                          style={{
                            width: 170,
                            height: 170,
                            borderRadius: 110,
                            border: "2px #565b60 solid",
                            background: "#565b60",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <span className="text-white text-uppercase" style={{ fontSize: "30px" }}>vj</span>
                        </div>

                        <div className="doc_type mt-3 mb-3">Create Contract</div>
                        <div className="row">
                          <div className="col-3">
                            <label
                              style={{
                                fontSize: 14,
                                marginRight: 20,
                                marginLeft: 0,
                              }}
                            >
                              Email :
                            </label>
                          </div>
                          <div className="col-8">
                            <label
                              style={{
                                fontSize: 14,
                                marginRight: 20,
                                marginLeft: 0,
                              }}
                            >
                              vjha8300@gmail.com
                            </label>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-3">
                            <label
                              style={{
                                fontSize: 14,
                                marginRight: 20,
                                marginLeft: 0,
                              }}
                            >
                              Phone Number :
                            </label>
                          </div>
                          <div className="col-8">
                            <label
                              style={{
                                fontSize: 14,
                                marginRight: 20,
                                marginLeft: 0,
                              }}
                            >
                              8474774575755
                            </label>
                          </div>
                        </div>



                        <div className="row">
                          <div className="col-3">
                            <label
                              style={{
                                fontSize: 14,
                                marginRight: 20,
                                marginLeft: 0,
                              }}
                            >
                              Gender :
                            </label>
                          </div>
                          <div className="col-8">
                            <label
                              style={{
                                fontSize: 14,
                                marginRight: 20,
                                marginLeft: 0,
                              }}
                            >
                              Male
                            </label>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-3">
                            <label
                              style={{
                                fontSize: 14,
                                marginRight: 20,
                                marginLeft: 0,
                              }}
                            >
                              Address :
                            </label>
                          </div>
                          <div className="col-8">
                            <label
                              style={{
                                fontSize: 14,
                                marginRight: 20,
                                marginLeft: 0,
                              }}
                            >
                              Rajasthan, Jaipur
                            </label>
                          </div>
                        </div>



                        <div className="row">
                          <div className="col-3">
                            <label
                              style={{
                                fontSize: 14,
                                marginRight: 20,
                                marginLeft: 0,
                              }}
                            >
                              Date of Birth :
                            </label>
                          </div>
                          <div className="col-8">
                            <label
                              style={{
                                fontSize: 14,
                                marginRight: 20,
                                marginLeft: 0,
                              }}
                            >
                              06-10-1998
                            </label>
                          </div>
                        </div>






                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default ViewUser;
